import {List, Map} from 'immutable';

import * as PreMatchMenuActions from 'actions/PreMatchMenu';
import * as LineActions from 'actions/Line';

export default function sportsReducer(sports, action) {
    switch (action.type) {
        case PreMatchMenuActions.SUCCESS_INIT_PREMATCH_MENU:
            return initMenu(new Map(), action.data);

        case LineActions.CLEAR_LINE:
            return new Map();
    }

    return sports;
}

function initMenu(sports, data) {
    if (data === undefined) {
        return sports;
    }

    if (data.sports !== undefined) {
        sports = addMenuSports(sports, data.sports.add);
    }
    if (data.leagues !== undefined) {
        sports = addSportLeagues(sports, data.leagues.add);
    }

    return sports;
}

function addMenuSports(sports, addSports) {
    if (addSports === undefined) {
        return sports;
    }

    sports = sports.withMutations(s => {
        for (let i = 0; i < addSports.length; i++) {
            let sport = new Map(addSports[i]);
            sport = sport.set('leagues', new List());

            s.set(sport.get('id'), sport);
        }
    });

    return sports;
}

function addSportLeagues(sports, addLeagues) {
    if (addLeagues === undefined) {
        return sports;
    }

    for (let i = 0; i < addLeagues.length; i++) {
        const sportId = addLeagues[i].sportId;
        const leagueId = addLeagues[i].id;

        (function (sportId, leagueId) {
            sports = sports.updateIn([sportId, 'leagues'], l => l.push(leagueId));
        })(sportId, leagueId);
    }

    return sports;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/menu/sportsReducer.js